import { render, staticRenderFns } from "./dnssecDeploy.vue?vue&type=template&id=b0f548a4&scoped=true"
import script from "./dnssecDeploy.vue?vue&type=script&lang=js"
export * from "./dnssecDeploy.vue?vue&type=script&lang=js"
import style0 from "./dnssecDeploy.vue?vue&type=style&index=0&id=b0f548a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f548a4",
  null
  
)

export default component.exports